import React from 'react';

import cx from 'classnames';

import s from './index.module.css';

export function NoResultFound() {
  return <div className={cx(s.wrapper, 'custom-add-flights-no-result-found')}>No Results Found</div>;
}
